import JiraSourceIcon from "../../assets/components/sources/JiraSourceIcon";

const JiraLogomark = ({ height }: { height: number }) => {
  return <JiraSourceIcon height={height} />;
};

export default JiraLogomark;
